export const callTel = (htmlStr) => {
  let reg = /call\(((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})))\)/
  htmlStr = htmlStr.replace(reg, function (m, p1) {
    return '<a href="tel:' + p1 + '">' + p1 + '</a>'
  })
  reg = /call\((0\d{2,3}-?\d{7,8})\)/ig
  htmlStr = htmlStr.replace(reg, function (m, p1) { return '<a href="tel:' + p1 + '">' + p1 + '</a>' })
  return htmlStr
}

export const handleImgSrc = (htmlStr) => {
  const reg = /<img[^>]*>/gi
  let n = 0
  // 处理img标签内容
  htmlStr = htmlStr.replace(reg, function (str, capture) {
    n += 1
    const srcReg = / src=['"]?([^'"]*)['"]?/i
    const dataSrcReg = /data-src=['"]?([^'"]*)['"]?/i
    const url = str.match(srcReg)
    const dataSrcurl = str.match(dataSrcReg)
    if (url === null && dataSrcurl === null) {
      // 没有匹配到结果，不处理
      return str
    }
    if (url && url != null && url[1]) {
      // 1.处理附件icon图标
      if (url[1] === 'https://mapdownload5.midea.com/file/v5/app/download/591007/public/logo/596011255.gif') {
        url[1] = 'dist/icon_txt.gif'
        str = str.substr(0, str.length - 1) + ' data-src="dist/icon_txt.gif" data-icon="1"' + '>'
      }
      // 2.不是外链网站的图片，图片路径含有/oss/auth/路径的，添加缩略图功能，并且赋值
      if (str.indexOf('ue-editor-image') > -1 && url[1] !== 'dist/icon_txt.gif' && url[1].indexOf('/oss/auth/') > -1) {
        const dataRatioReg = /data-ratio=['"]?([^'"]*)['"]?/i
        const dataRatio = str.match(dataRatioReg)
        const dataOriginReg = /data-origin=['"]?([^'"]*)['"]?/i
        console.log(dataOriginReg)
        const dataOrigin = str.match(dataOriginReg)
        console.log(dataOrigin)
        const dataWReg = /data-w=['"]?([^'"]*)['"]?/i
        const dataW = str.match(dataWReg)
        let clientWidth = (document.documentElement.clientWidth || document.body.clientWidth) > 750 ? 750 : document.documentElement.clientWidth || document.body.clientWidth
        if (dataW !== null && dataW[1] !== null && clientWidth > dataW[1]) {
          clientWidth = dataW[1]
        }
        url[1] += `?x-oss-image=image/resize%2cm_fixed%2cw_${clientWidth}`
        str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, function (match, capture) {
          const thumbnailType = ['jpg', 'jpeg', 'bmp', 'png']
          if (
            dataOrigin === null && dataRatio !== null &&
              dataRatio[1] !== null && capture &&
              capture.indexOf('.') > -1 && thumbnailType.indexOf(capture.split('.').pop()) > -1 &&
              Math.floor(clientWidth * dataRatio[1] < 1024) &&
              dataRatio[1] < 3
          ) {
            str = str.replace(
              new RegExp(capture, 'g'),
              capture +
              `?x-oss-image=image/resize%2cm_fixed%2cw_${clientWidth * 2}%2ch_${Math.floor(clientWidth * dataRatio[1] || clientWidth) * 2}`
            )
          } else if (
            dataOrigin === null && dataRatio !== null &&
            dataRatio[1] !== null && capture &&
            capture.indexOf('.') > -1 && thumbnailType.indexOf(capture.split('.').pop()) > -1 &&
            Math.floor(clientWidth * dataRatio[1] >= 1024) && Math.floor(clientWidth * dataRatio[1] <= 2048) &&
            dataRatio[1] < 3
          ) {
            // 按高度2048取值
            str = str.replace(
              new RegExp(capture, 'g'),
              capture +
              `?x-oss-image=image/resize%2cm_fixed%2cw_${Math.floor(2048 / dataRatio[1])}%2ch_2048`
            )
          } else {
            str = str.replace(new RegExp(capture, 'g'), capture)
          }
        })
      }
      // 3.处理有src没有data-src的情况
      if (dataSrcurl === null || dataSrcurl[1] === '') {
        if (dataSrcurl === null) {
          str = str.substr(0, str.length - 1) + ` data-src="${url[1]}"` + '>'
        } else {
          str = str.replace(/data-src/, 'data-none')
          str = str.substr(0, str.length - 1) + ` data-src="${url[1]}"` + '>'
        }
      }
      // 4.从第4个图开始，去掉img标签的src属性
      // 资讯中心的文章不适用
      if (n > 3 && window.location.hash.split('?')[0].substr(1).indexOf('content') === -1) {
        if (!(str.indexOf('data-src="dist/icon_txt.gif"') > -1)) {
          str = str.replace(/ src=['"]?([^'"]*)['"]?/i, ' ')
          str = str.substr(0, str.length - 1) + ' preview="1"' + '>'
        } else {
          str = str.replace(/ src=['"]?([^'"]*)['"]?/i, ' src="dist/icon_txt.gif"')
        }
        return str
      } else {
        if (!(str.indexOf('data-src="dist/icon_txt.gif"') > -1)) {
          str = str.substr(0, str.length - 1) + ' preview="1"' + '>'
        } else {
          str = str.replace(/ src=['"]?([^'"]*)['"]?/i, ' src="dist/icon_txt.gif"')
        }
        return str
      }
    } else {
      return str
    }
  })
  return htmlStr
}

export const lazyVideoSrc = (htmlStr) => {
  let k = 0
  // console.log(k)
  const newContent = htmlStr.replace(/<video[^>]*>/gi, function (str, capture) {
    // console.log('---------video-------------')
    // console.log(str)
    // console.log('---------video-------------')
    k++
    // console.log(k)
    // 要区分重构版本与旧版本，重构版本因为加入了video.js，需要引入video标签内层引入source标签做浏览器兼容，如果没有source标签
    // 将会造成播放器无法播放。所以，要在匹配到的表达式后面加入source标签
    let matPlusPreview = ''
    if (str.indexOf('class="video-js') > -1) {
      matPlusPreview = str.substr(0, str.length - 1) + `  id="myVideo${String(k)}" preload="metadata" playsinline="playsinline" ` + '>'
    } else {
      const srcReg = /src=['"]?([^'"]*)['"]?/i
      const url = str.match(srcReg)
      // console.log('url', url[1])
      matPlusPreview = `<video src="${url[1]}" style="max-width: 100%;"  class="video-js vjs-big-play-centered" data-setup="{}" width="360" height="202" id="myVideo${String(k)}" preload="none" playsinline><source src="${url[1]}"></source>`
    }
    return matPlusPreview
  })
  return [newContent, k]
}

export const handleAttachmentSrc2 = (htmlStr) => {
  const reg = /(<a[^>]*)href.*?<\/a>/gi
  const reg2 = /(<a[^>]*)href/gi
  console.log(reg)
  htmlStr = htmlStr.replace(reg, function (m, p1) {
    if (m.indexOf(' title="') > -1) {
      m = m.replace(reg2, function (n, p2) {
        return p2 + 'data-href'
      })
      return m
    } else {
      return m
    }
  })
  return htmlStr
}

export const handleAttachmentSrc = (htmlStr) => {
  // 1.匹配a标签
  const reg = /(<a[^>]*)href.*?<\/a>/gi
  const reg2 = /(<a[^>]*)href/gi
  htmlStr = htmlStr.replace(reg, function (str, capture) {
    // 2.匹配href里的值
    const hrefReg = / href=['"]?([^'"]*)['"]?/i
    const href = str.match(hrefReg)
    if (href === null) {
      // 没有匹配到结果，不处理
      return str
    } else {
      // 对a标签的href进行解析
      if (href[1] !== null) {
        // 3.判断是否是附件过程
        const suffix = href[1].split('.').pop()
        if (suffix.length > 0 && suffix.length < 5 && suffix.indexOf('/') === -1) {
          console.log('hahahahahahah')
          const passSuffix = ['html', 'php', 'jsp', 'asp', 'htm', 'aspx', 'com', 'cn']
          if (passSuffix.indexOf(suffix) === -1) {
            // 这是附件
            str = str.replace(reg2, function (n, p2) {
              return p2 + 'data-href'
            })
            return str
          } else {
            // 这是网页
            return str
          }
        } else {
          // 这是网页
          return str
        }
      } else {
        // 没有href?
        // 没有匹配到结果，不处理
        return str
      }
    }
  })
  return htmlStr
}

export const formatDate = (time, format) => {
  const t = new Date(time)
  const tf = function (i) {
    return (i < 10 ? '0' : '') + i
  }
  return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
    switch (a) {
      case 'yyyy':
        return tf(t.getFullYear())
      case 'MM':
        return tf(t.getMonth() + 1)
      case 'mm':
        return tf(t.getMinutes())
      case 'dd':
        return tf(t.getDate())
      case 'HH':
        return tf(t.getHours())
      case 'ss':
        return tf(t.getSeconds())
    }
  })
}
